import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import ENV from '../../base/env';
import './SelectionItem.scss';
import { ISelectionItem } from './types';

export interface IProps extends ISelectionItem {
  type: 'large' | 'regular' | 'special_needs';
  onSelect: (group: number) => void;
}

const SelectionItem: React.FC<IProps> = ({ onSelect, title, id, description, imgSrc, type }) => {
  const { t } = useTranslation();

  const handleSelect = () => {
    onSelect(id);
  };
  const tTitle = t(title);
  const titleClass = `selection-item-title ${type === 'regular' ? 'nn-h1' : ''}`;
  const renderImage = () => <img className="selection-item-image" src={`${ENV.AssetsBaseUrl}${imgSrc}`} alt={tTitle} />;
  return (
    <button className="selection-item" onClick={handleSelect}>
      <h3 className={titleClass}>{tTitle}</h3>
      {!!imgSrc && renderImage()}
      <span className="selection-item-description">{t(description)}</span>
    </button>
  );
};

export default SelectionItem;
